exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".assignment{padding:15px;position:relative;background-color:#fff}.assignment h1{margin-top:5px}.assignment.level-Gold{border-bottom:2px solid gold}.assignment.level-Gold .points{color:#fff;background-color:gold}.assignment.level-Bronze{border-bottom:2px solid #cd7f32},.assignment.level-Bronze .points{color:#fff;background-color:#cd7f32}.assignment.level-Silver{border-bottom:2px solid silver}.assignment.level-Silver .points{color:#fff;background-color:silver}.tooltip-container .none{color:#000;font-size:1em;background-color:#eee;cursor:pointer}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/assignment/assignment.component.css
// module id = 495
// module chunks = 1